import Vue from "vue";
import App from "./App.vue";
import { router } from "@/router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import VueKonva from "vue-konva";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
// @ts-ignore
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@/core/plugins/blockui";
import "@/core/plugins/toast";
import "@/core/plugins/vuelidate";
import "@/core/plugins/searchSelect";
import "@mdi/font/css/materialdesignicons.css";
import "@/core/plugins/vmask";
import "./scrolly/index";
import "@/core/plugins/formvalidation";
import "@/core/plugins/formatdatetime";
import "@/core/plugins/confirmDialog";
import TokenService from "./core/services/tokenservice";
import moment from "moment";

//Call Parent Iframe Loaded
//var sourceURL = document.referrer;
//window.parent.postMessage("1", sourceURL);

// API service init
ApiService.init();

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = TokenService.getLocalAccessToken();
    const TokenExpiryTime = TokenService.getTokenExpiryTime();
    var diff = moment
      .utc(TokenExpiryTime)
      .local()
      .diff(moment.utc().local());
    if ((token == null || diff < 0 )) {
      next("/401");
    } else {
      next();
    }
  } else {
    next();
  }
});

/* router.beforeEach((to, from, next) => {
  console.log("to", to);
  console.log("next", next);
  alert("1");
  if (to.meta.requiresAuth) {
    console.log("requiresAuth");
    alert("2");
    const token = TokenService.getLocalAccessToken();
    const TokenExpiryTime = TokenService.getTokenExpiryTime();
    var diff = moment
      .utc(TokenExpiryTime)
      .local()
      .diff(moment.utc().local());
    console.log("token", token);
    console.log("diff", diff);

    if (token == null || diff < 0) {
      alert("3");
      if (to.path !== "/401") {
        next("/401"); // فقط ریدایرکت کن اگر در حال حاضر در صفحه 401 نیستی
        alert("4");
      } else {
        next(); // در صورتی که قبلاً ریدایرکت شده باشی، نگذار دوباره ریدایرکت بشه
        alert("5");
      }
    } else {
      // کاربر وارد شده، اجازه بده به مسیر بعدی
      if (to.path !== "/virtualLogin") {
        alert("6");
        next("/virtualLogin"); // فقط ریدایرکت کن اگر کاربر در صفحه virtualLogin نباشه
      } else {
        alert("7");
        next(); // در غیر این صورت، اجازه بده ادامه پیدا کنه
      }
    }
  } else {
    alert("8");
    next(); // مسیرهایی که نیاز به auth ندارند، ادامه بده
  }
}); */

Vue.use(VueKonva);

new Vue({
  router,
  store,
  i18n,
  // @ts-ignore
  vuetify,
  render: (h) => h(App, {}),
}).$mount("#app");
